"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTypeSchema = exports.PAGE_SUB_TYPES = exports.PAGE_TYPES = void 0;
const zod_1 = require("zod");
// Primary page types so we can use them in the tracking events
exports.PAGE_TYPES = {
    HOME_PAGE: "Home Page",
    // main funnel
    SEARCH: "Search Page",
    // facility pages
    FACILITY: "Facility Page",
    // reservation
    RESERVE: "Reserve Page",
    CONFIRMATION: "Confirmation Page",
    // Search LPs
    CITY_LANDING: "City Landing Page",
    STATE_LANDING: "State Landing Page",
    // PSPs
    PSP: "Product Subject Page",
    // others
    REVIEW: "Review Page",
    REBATE: "Rebate Page",
    REBATE_STATUS: "Rebate Status Page",
    UNSUBSCRIBE: "Unsubscribe Page",
    CONTACT: "Contact Page",
    LEGAL: "Legal Page",
    ERROR: "Error Page",
    PPC: "Marketing Landing Page",
    VEHICLE_LENGTH: "Vehicle Length Page",
    CLAIM_LISTING: "Claim Listing",
};
// Sub page types we'll continue using for logic
// page types we didn't include from the original enum
exports.PAGE_SUB_TYPES = {
    // facility pages
    OON_FACILITY: 'oonFacilityPage',
    HIDDEN_FACILITY: 'hiddenFacilityPage',
    // Search LPs
    AMENITY_LANDING: 'amenityLandingPage',
    VEHICLE_LANDING: 'vehicleLandingPage',
    ZIP_LANDING: 'zipLandingPage',
    NEIGHBORHOOD_LANDING: 'neighborhoodLandingPage',
    // PSPs
    SIZE_LANDING: 'sizeLandingPage',
    CLIMATE_CONTROLLED_LANDING_PAGE: 'climateControlledLandingPage',
    BUSINESS_LANDING: 'storageBusinessLandingPage',
    STORAGE_LANDING: 'storageLandingPage',
    CAR_LANDING: 'storageCarLandingPage',
    RV_LANDING: 'storageRvLandingPage',
    BOAT_LANDING: 'storageBoatLandingPage',
    // PSPs (old)
    COLLEGE_LANDING: 'storageCollegeLandingPage',
    WINE_STORAGE_LANDING: 'storageWineLandingPage',
    // FSS
    FSS_LANDING: 'fssLandingPage',
    FSS_FACILITY: 'fssFacilityPage',
    FSS_CITY_LANDING: 'fssCityLandingPage',
    // others
    MOVING_TRUCK_CLP: 'movingTruckCityLandingPage',
    MOVING_TRUCK_PSP: 'movingTruckLandingPage',
    MOVING_SUPPLIES_PSP: 'suppliesLandingPage',
    PORTABLE_STORAGE_CLP: 'portableStorageCityLandingPage',
    PORTABLE_STORAGE_PSP: 'portableStorageLandingPage',
    CHEAP_STORAGE_PRICES_LANDING: 'cheapStoragePricesLandingPage',
    STORAGE_NEAR_ME_LANDING: 'storageNearMeLandingPage',
    STORAGE_BASICS_LANDING_PAGE: 'storageBasicsLandingPage',
    STORAGE_DEALS_LANDING: 'storageDealsLandingPage',
    COMPARE: 'comparePage',
    AAA_OFFER: 'aaaOfferPage',
    ABOUT: 'aboutPage',
    PARTNERS: 'partnersPage',
    INVESTORS: 'investorsPage',
    BROKERS: 'brokersPage',
    PRESS: 'pressPage',
    REBATE_REDEMPTION_REQUEST: 'rebateRedemptionRequestPage',
    ADD_FACILITY: 'addFacility',
    CONFIRM_MOVE_IN: 'confirmMoveIn',
    CONFIRM_NO_MOVE_IN: 'confirmNoMoveIn'
};
// Original enum we are seperating into two enums
// var PageTypes = {
//   // main funnel
//   HOME: 'homePage',
//   SEARCH: 'searchPage',
//   // facility pages
//   FACILITY: 'facilityPage',
//   OON_FACILITY: 'oonFacilityPage',
//   HIDDEN_FACILITY: 'hiddenFacilityPage',
//   // reservation
//   RESERVE: 'reservePage',
//   CONFIRMATION: 'confirmationPage',
//   // Search LPs
//   CITY_LANDING: 'cityLandingPage',
//   UNPUBLISHED_CITY_LANDING: 'unpublishedCityLandingPage',
//   AMENITY_LANDING: 'amenityLandingPage',
//   VEHICLE_LANDING: 'vehicleLandingPage',
//   STATE_LANDING: 'stateLandingPage',
//   ZIP_LANDING: 'zipLandingPage',
//   NEIGHBORHOOD_LANDING: 'neighborhoodLandingPage',
//   // PSPs
//   SIZE_LANDING: 'sizeLandingPage',
//   CLIMATE_CONTROLLED_LANDING_PAGE: 'climateControlledLandingPage',
//   BUSINESS_LANDING: 'storageBusinessLandingPage',
//   STORAGE_LANDING: 'storageLandingPage',
//   CAR_LANDING: 'storageCarLandingPage',
//   RV_LANDING: 'storageRvLandingPage',
//   BOAT_LANDING: 'storageBoatLandingPage',
//   // PSPs (old)
//   COLLEGE_LANDING: 'storageCollegeLandingPage',
//   WINE_STORAGE_LANDING: 'storageWineLandingPage',
//   // FSS
//   FSS_LANDING: 'fssLandingPage',
//   FSS_FACILITY: 'fssFacilityPage',
//   FSS_CITY_LANDING: 'fssCityLandingPage',
//   // others
//   MOVING_TRUCK_CLP: 'movingTruckCityLandingPage',
//   MOVING_TRUCK_PSP: 'movingTruckLandingPage',
//   MOVING_SUPPLIES_PSP: 'suppliesLandingPage',
//   PORTABLE_STORAGE_CLP: 'portableStorageCityLandingPage',
//   PORTABLE_STORAGE_PSP: 'portableStorageLandingPage',
//   CHEAP_STORAGE_PRICES_LANDING: 'cheapStoragePricesLandingPage',
//   STORAGE_NEAR_ME_LANDING: 'storageNearMeLandingPage',
//   STORAGE_BASICS_LANDING_PAGE: 'storageBasicsLandingPage',
//   STORAGE_DEALS_LANDING: 'storageDealsLandingPage',
//   REVIEW: 'reviewPage',
//   REBATE: 'rebatePage',
//   REBATE_STATUS: 'rebateStatusPage',
//   COMPARE: 'comparePage',
//   AAA_OFFER: 'aaaOfferPage',
//   ABOUT: 'aboutPage',
//   UNSUBSCRIBE: 'unsubscribePage',
//   CONTACT: 'contactPage',
//   PARTNERS: 'partnersPage',
//   LEGAL: 'legalPage',
//   INVESTORS: 'investorsPage',
//   BROKERS: 'brokersPage',
//   PRESS: 'pressPage',
//   ERROR: 'errorPage',
//   PPC: 'marketingLandingPage',
//   REBATE_REDEMPTION_REQUEST: 'rebateRedemptionRequestPage',
//   VEHICLE_LENGTH: 'vehicleLengthPage',
//   CLAIM_LISTING: 'claimListing',
//   ADD_FACILITY: 'addFacility',
//   CONFIRM_MOVE_IN: 'confirmMoveIn',
//   CONFIRM_NO_MOVE_IN: 'confirmNoMoveIn'
// };
exports.PageTypeSchema = zod_1.z.enum(Object.values(exports.PAGE_TYPES));
//# sourceMappingURL=page-types.js.map